import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { css as cssClassname } from '@emotion/css';

import { N50, R500 } from '@/colors/colorsV1';
import { border, display, flexbox, sizing, spacing } from '../styled-system';

/**
 * Card Style
 */
export const StyledCard = styled.div`
  ${({ color, error, isBorder, isShadow }) => css`
    background-color: ${color};
    border-radius: 8px;
    transition: border-color 0.15s linear;
    ${isBorder &&
    css`
      border: 1px solid ${N50};
    `};
    ${isBorder &&
    error &&
    css`
      border: 1px solid ${R500};
    `};
    ${isShadow &&
    css`
      box-shadow: rgb(51 51 51 / 12%) 0px 0px 12px 0px, rgb(51 51 51 / 8%) -1px -1px 12px -6px;
    `};
  `};
  ${border}
  ${display};
  ${flexbox};
  ${spacing};
  ${sizing};
`;

/**
 * Card Container/Wrapper - only receive spacing(margin)
 */
export const CardContainer = styled.div`
  ${spacing}
`;

/**
 * Error Message Style
 * @param {{ show: boolean }} props
 * @returns
 */
export const styErrorMessage = ({ show }) => cssClassname`
  margin-top: ${show ? '4px' : '0px'};
  max-height: ${show ? '100px' : '0px'};
  overflow: hidden;
  transition: max-height 0.15s ease-in-out, margin-top 0.15s linear;
`;
